import { render, staticRenderFns } from "./do_changes.vue?vue&type=template&id=3f04373a&scoped=true&lang=html&"
import script from "./do_changes.vue?vue&type=script&lang=js&"
export * from "./do_changes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04373a",
  null
  
)

export default component.exports